import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [manager, setManager] = useState(null);
  const [status, setStatus] = useState("loading"); // loading | authed | guest

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("jb_token");
    if (!token) {
      setStatus("guest");
      setManager(null);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setManager(data);
      setStatus("authed");
    } catch (e) {
      localStorage.removeItem("jb_token");
      setManager(null);
      setStatus("guest");
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("jb_token", data.access_token);
      setManager(data.manager);
      setStatus("authed");
      return { ok: true, manager: data.manager };
    } catch (e) {
      return { ok: false, error: formatApiError(e?.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // ignore
    }
    localStorage.removeItem("jb_token");
    // Phase 12: also clear the banner-dismiss flag so the next manager on this browser
    // sees their own subscription banner state, not the previous account's.
    localStorage.removeItem("jb_sub_dismiss_until");
    setManager(null);
    setStatus("guest");
  };

  return (
    <AuthContext.Provider value={{ manager, status, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
